import styled, { css } from 'styled-components'
import { theme } from '@acorns/grove'
import Markdown from 'react-markdown'

export const Container = styled.div<{ animate: boolean }>`
  position: absolute;
  min-height: 66px;
  align-items: center;
  background-color: ${theme.colors.naturalCloud};
  border-bottom: 1px solid rgba(25, 25, 25, 0.05);
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 11;
  white-space: pre-line;
  
  ${props =>
    props.animate &&
    css`
      transform: translateY(-100%);
      transition: transform 600ms;
      transition-timing-function: cubic-bezier(0.5, 0, 0, 1);

      &.animated {
        transform: translateY(0%);
      }
    `}

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    min-height: 80px;
  }
`

export const IconContainer = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  margin-left: 16px;
  display: flex;
  justify-content: flex-start;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-left: 30px;
  }
`

export const BannerIcon = styled.img`
  max-width: 60px;
`

export const DismissContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  flex-basis: 0;
  margin-right: 16px;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-right: 30px;
  }
`

export const BannerTitle = styled(Markdown as any)`
  margin: 0 10px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`
